module.exports = __webpack_public_path__ + "static/media/corporate-services-img72.b5aa1879.jpg";